<script>
    import Turnstile from "./Turnstile.svelte";
    import UserIcon from "$lib/images/user.svg";
    import PassIcon from "$lib/images/pass.svg";
    import axiosInstance from "$lib/js/axios";
    import Spinner from "./Spinner.svelte";
    import { selectStep } from "/src/store";

    export let nextStep;
    export let changeFormStep;

    let login = "";
    let password = "";
    let token = "";

    let login_error = "";
    let password_error = "";
    let turnstile_error = "";
    let error_message = "";
    let isSubmitting = false;
    let showPassword = false;

    async function handleLogin() {
        login_error = password_error = turnstile_error = error_message = "";
        isSubmitting = true;

        if (!login || login.length < 3) {
            login_error = "Логін має містити мінімум 3 символи.";
        }

        if (!password || password.length < 6) {
            password_error = "Пароль має бути мінімум 6 символів.";
        }

        if (!token) {
            turnstile_error = "Проблема з перевіркою. Спробуйте ще раз.";
        }

        if (login_error || password_error || turnstile_error) {
            isSubmitting = false;
            return;
        }

        const formData = new FormData();
        formData.append("login", login);
        formData.append("password", password);
        formData.append("cf_turnstile_token", token);

        try {
            const res = await axiosInstance.post("/login/", formData);
            if (res.data.status === true) {
                if (typeof document !== "undefined" && document.body) {
                    window.dataLayer.push({ event: "login_succes" });
                }
                selectStep.set("");
                nextStep();
            }
        } catch (err) {
            error_message = err?.response?.data?.detail || "Помилка авторизації.";
        } finally {
            isSubmitting = false;
        }
    }
</script>

<form on:submit|preventDefault={handleLogin}>
    <div class="inputs">
        <label class="input" class:error={login_error}>
            <div class="icon"><img src={UserIcon} alt="Login" /></div>
            <input type="text" name="login" placeholder="Введіть логін" bind:value={login} autocomplete="on" required />
        </label>
        {#if login_error}
            <span class="span-error">{login_error}</span>
        {/if}

        <label class="input" class:error={password_error}>
            <div class="icon"><img src={PassIcon} alt="Password" /></div>
            {#if showPassword}
                <input
                    type="text"
                    name="password"
                    bind:value={password}
                    placeholder="Введіть пароль"
                    autocomplete="on"
                    required
                />
            {:else}
                <input
                    type="password"
                    name="password"
                    bind:value={password}
                    placeholder="Введіть пароль"
                    autocomplete="on"
                    required
                />
            {/if}
            <button type="button" class="eye" on:click={() => (showPassword = !showPassword)}>
                {showPassword ? "🙈" : "👁️"}
            </button>
        </label>

        {#if password_error}
            <span class="span-error">{password_error}</span>
        {/if}

        {#if error_message}
            <span class="span-error">{error_message}</span>
        {/if}
    </div>
    {#if turnstile_error}
        <span class="span-error">{turnstile_error}</span>
    {/if}

    <div class="form-buttons">
        <div class="payment-button">
            <button class="btn btn-no-primary" type="button" on:click={() => changeFormStep("register")}>
                В МЕНЕ НЕМАЄ АКАУНТУ
            </button>
        </div>
        <div class="payment-button">
            <button class="btn btn-primary" disabled={isSubmitting}>
                {isSubmitting ? "Перевірка..." : "ПІДТВЕРДИТИ"}
            </button>
        </div>
    </div>
    <div style="margin-left: auto; margin-right: auto; margin-top: 30px;">
        <Turnstile on:token={e => (token = e.detail)} />
    </div>
</form>

<Spinner isSpinner={isSubmitting} />

<style lang="scss">
    @import "/src/lib/scss/main";

    .span-error {
        color: #e74e4e;

        &:empty {
            display: none;
        }
    }

    .span-success {
        color: #24c03a;

        &:empty {
            display: none;
        }
    }

    form {
        width: 580px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding: 0 10px 0 10px;

        .input {
            position: relative;

            .eye {
                position: absolute;
                right: 12px;
                top: 50%;
                transform: translateY(-50%);
                background: none;
                border: none;
                cursor: pointer;
                font-size: 16px;
                color: #fff;
            }

            input {
                padding-right: 36px;
            }
        }

        & > .inputs {
            display: flex;
            flex-direction: column;
            width: 100%;
            gap: 15px;

            & > .error {
                border: 0.5px solid #9f0b0b !important;
            }

            .dropdown-img {
                width: 24px;
                height: 24px;
            }

            .arrow-img {
                width: 12px;
                height: 17px;
                transition: transform 0.3s ease;

                &.rotate {
                    transform: rotate(-180deg);
                }
            }
        }

        .payment-button {
            width: 100%;
            height: 64px;

            & > button {
                font-size: 18px;
                line-height: 140%;
                text-transform: uppercase;
                // color: #232323;
                font-weight: 900;
                font-style: italic;
            }
        }

        .bonus-main {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            row-gap: 10px;
        }

        .bonus-wrapper {
            display: flex;
            align-items: center;

            .bonus {
                border-radius: 10px;
                width: 47px;
                height: 25px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 900;
                font-style: italic;
                font-size: 9pt;
                color: #0f0f0f;
                background: #fed500;
                margin-right: 10px;
            }

            p {
                font-weight: normal;
                font-style: normal;
                font-size: 9pt;
                color: #fffbef;
            }
        }

        & > .checkbox {
            color: #fffbef;

            p {
                font-size: 11pt;
                line-height: 140%;
                font-weight: 400;
                color: rgba(255, 255, 255, 0.4);

                a {
                    font-weight: 500;
                    text-decoration: underline;
                    text-decoration-skip-ink: none;
                    color: #fffbef;
                }
            }
        }
    }

    .form-buttons {
        display: flex;
        // flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        gap: 20px;

        @media (max-width: 768px) {
            flex-direction: column;
            gap: 12px;
        }
    }

    @media (max-width: 768px) {
        form {
            width: 100%;
            padding: 0 20px;

            .payment-button {
                height: auto;

                & > button {
                    width: 100%;
                    padding: 14px 0;
                    font-size: 16px;
                }
            }

            .inputs {
                gap: 12px;
            }

            .checkbox {
                p {
                    font-size: 10pt;
                    line-height: 130%;
                    text-align: left;
                }
            }

            .span-error {
                font-size: 12px;
            }

            .input {
                input {
                    font-size: 14px;
                    padding: 12px 50px 12px 50px;
                }

                .eye {
                    font-size: 14px;
                    right: 10px;
                }

                .icon img {
                    width: 20px;
                    height: 20px;
                }
            }
        }
    }
</style>
